import { render, staticRenderFns } from "./translateApprove.vue?vue&type=template&id=9a629daa&scoped=true"
import script from "./translateApprove.vue?vue&type=script&lang=js"
export * from "./translateApprove.vue?vue&type=script&lang=js"
import style0 from "./translateApprove.vue?vue&type=style&index=0&id=9a629daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a629daa",
  null
  
)

export default component.exports